var _g, _g2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserInquiry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.4,
    height: 22,
    viewBox: "0 0 21.4 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "user-inquiry"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1, 0.05, -0.05, 1, 12.29, 10.21)",
    fontSize: 9.5,
    fill: "{props.color}",
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "?"), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.6,11.4a3,3,0,0,1,3-3,3.08,3.08,0,0,1,3,3,3.08,3.08,0,0,1-3,3A3,3,0,0,1,8.6,11.4Zm.7,0a2.2,2.2,0,1,0,2.2-2.2A2.22,2.22,0,0,0,9.3,11.4Z",
    transform: "translate(-2.3 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7,19.3c0-1.8-1.9-3.3-4.1-3.3s-4.1,1.5-4.1,3.3a.4.4,0,0,1-.8,0c0-2.2,2.2-4.1,4.9-4.1s4.9,1.8,4.9,4.1a.4.4,0,1,1-.8,0Z",
    transform: "translate(-2.3 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_142",
    "data-name": "Capa 142"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.7,
    cy: 11,
    rx: 10,
    ry: 10.3,
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 1.4
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-2.3 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-2.3 -0.4)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInquiry);
export default __webpack_public_path__ + "static/media/user-inquiry.db0808a06ce8670af7c71744df70b9a3.svg";
export { ForwardRef as ReactComponent };